// extracted by mini-css-extract-plugin
export default {"button":"Iyrxt","rotate":"H1zua","tablet":"PNobN","desktop":"nfd_V"};